import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    paddingBottom: 24,
    '& .info-card': {
      background: Colors.white,
      padding: 16,
      borderRadius: 8,
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
    },
  },
};

export default styles;
